import {X} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const CloseIcon = createLucideIcon(X, 'CloseIcon');
